import { defineStore } from "pinia";

import { ActivationService } from "@core/services";
import { DemandRecapModel } from "@core/models";
import { ACTION_ACTIVATION_GET_DEMAND_RECAP, GETTER_ACTIVATION_GET_DEMAND_RECAP } from "@etab/stores/types";

export const useActivationStore = defineStore("activation", {
  // convert to a function
  state: () => ({
    demandRecap: {},
  }),
  getters: {
    [GETTER_ACTIVATION_GET_DEMAND_RECAP]: (state) => new DemandRecapModel(state.demandRecap),
  },
  actions: {
    async [ACTION_ACTIVATION_GET_DEMAND_RECAP](demandId) {
      const recap = await ActivationService.getRecap({ demandId });
      this.demandRecap = recap;
    },
    // easily reset state using `$reset`
    clearActivationStore() {
      this.$reset();
    },
  },
});
